import moment from 'moment';
import { EditProfile } from '_components/Profile/EditProfile';
import { preventNegativeValueInDocs, formatDate } from '_helpers/helpers';
import { dateTimeConstants } from '_constants';
import DatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import PropTypes from "prop-types";

export default function GeneralQualification({
  profileData,
  refetchUser,
  currentUserPermissions,
  authUser,
  dropdownData,
}) {
  return (
    <div className='mb-2'>
      <div className='qualifications_header-tab'>
        <h3>General Qualification</h3>
      </div>
      <div className='qualifications_header-tab'>
        <div className='qualification-row'>
          <label>Qualification</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>
                {profileData.general_qualification
                  ? profileData.general_qualification
                  : '-'}
              </span>
            </div>
            <EditProfile
              label='Qualification'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Qualifications',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>Qualification</label>
                  <select
                    {...register('general_qualification_id', {})}
                    defaultValue={profileData.general_qualification_id}
                    className={
                      errors.general_qualification_id &&
                      'profile-form-field-error'
                    }
                  >
                    <option value=''>Select Qualification</option>
                    {(dropdownData?.GeneralQualification ?? []).map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {errors.general_qualification_id && (
                    <p className='error-message'>
                      {errors.general_qualification_id.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>

        <div className='qualification-row'>
          <label>RT-130</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>{formatDate(profileData.rt_130_expiry)}</span>
            </div>
            <EditProfile
              label='RT-130'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={false}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Expiry/Assigned Dates',
              )}
            >
              {(register, errors, setValue, control) => (
                <>
                  <label>RT-130</label>
                  <Controller
                    name='rt_130_expiry'
                    control={control}
                    defaultValue={
                      profileData.rt_130_expiry
                        ? moment(profileData.rt_130_expiry).format(
                            dateTimeConstants.DATE_FORMAT,
                          )
                        : null
                    }
                    rules={{
                      required: 'RT-130 is required',
                    }}
                    render={({
                      field: { onChange, value },
                      fieldState: { error },
                    }) => (
                      <DatePicker
                        selected={value ? moment(value) : ''}
                        onChange={(date) =>
                          onChange(
                            date &&
                              !date.endOf('day').isAfter(moment().endOf('day'))
                              ? date.format(dateTimeConstants.DATE_FORMAT)
                              : '',
                          )
                        }
                        customInput={<input inputMode='none' />}
                        maxDate={moment()}
                        showMonthDropdown
                        showYearDropdown
                        placeholderText='Select RT 130 Expiry Date'
                        className={error ? 'profile-form-field-error' : ''}
                        dateFormat={dateTimeConstants.DATE_FORMAT}
                        showPopperArrow={false}
                      />
                    )}
                  />
                  {errors.rt_130_expiry && (
                    <p className='error-message'>
                      {errors.rt_130_expiry.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>

        <div className='qualification-row'>
          <label>Fire Seasons</label>
          <div className='input-like-box'>
            <div className='input-like-box_field'>
              <span>{profileData.fire_seasons ?? '-'}</span>
            </div>
            <EditProfile
              label='Fire Seasons'
              profileData={profileData}
              refetchUser={refetchUser}
              authUser={authUser}
              hasPermissionRequiredToEditOwn={true}
              hasPermissionToEditOthers={currentUserPermissions.includes(
                'Manage Employee Profile Fields',
              )}
            >
              {(register, errors) => (
                <>
                  <label>Fire Seasons</label>
                  <input
                    type='number'
                    {...register('fire_seasons', {
                      min: {
                        value: 0,
                        message: 'Fire Seasons must be a valid value',
                      },
                      validate: (value) =>
                        value.toString().length <= 3 ||
                        'Fire Seasons must be at most 3 digits',
                      valueAsNumber: true,
                    })}
                    placeholder='Enter Fire Seasons'
                    defaultValue={profileData.fire_seasons}
                    className={
                      errors.fire_seasons && 'profile-form-field-error'
                    }
                    onWheel={(e) => e.target.blur()}
                    onKeyDown={preventNegativeValueInDocs}
                  />
                  {errors.fire_seasons && (
                    <p className='error-message'>
                      {errors.fire_seasons.message}
                    </p>
                  )}
                </>
              )}
            </EditProfile>
          </div>
        </div>
      </div>
    </div>
  );
}

GeneralQualification.propTypes = {
  profileData: PropTypes.object.isRequired,
  refetchUser: PropTypes.func,
  currentUserPermissions: PropTypes.array,
  authUser: PropTypes.any,
  dropdownData: PropTypes.object,
};
